import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from 'components/Button/Button';
import React from 'react';

const MessageContent = ({ message, onCTAClick }) => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        maxWidth: 720,
        mt: 3,
        p: 2,
      }}
    >
      <Paper
        sx={{
          p: 3,
          backdropFilter: 'blur(30px)',
          bgcolor: 'rgba(255, 255, 255, 0.4)',
        }}
      >
        <Box
          dangerouslySetInnerHTML={{
            __html: message.notes_text,
          }}
        />
      </Paper>
      {message.call_to_action_enabled === '1' && (
        <Box mt={3}>
          <Button
            size="large"
            sx={{ px: 10 }}
            component="a"
            onClick={onCTAClick}
            target={message.is_popup_view === '1' ? '_blank' : '_self'}
            href={message.call_to_action}
          >
            {message.call_to_action_text}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default MessageContent;
